import { SetupFunction } from 'vue';
import { cartBus, CartModalEvents } from '@/modules/ecommerce/components/CartModal.events';
import { trans, Trans } from '@/domain/dao/Translations';

type Props = {
	label: string;
	cartRoute: string;
	title: string;
};

type View = {
	lang: Trans;
	openCartModal: () => void;
};

const viewCartController: SetupFunction<Props, View> = (props: Props): View => ({
	lang: trans(),
	openCartModal: () => {
		cartBus.emit(CartModalEvents.Open, {
			cartRoute: props.cartRoute,
			title: props.title,
		});
	},
});

export { Props, View, viewCartController };
